const Axios = require("axios")
const Http = Axios.create()
import { Notify } from 'vant'
Http.interceptors.request.use(
	(config) => {
		//const concator = config.url.includes("?") ? "&" : "?"
		//const authstr = "loginid=" + sessionStorage.getItem("SuserId")
		//config.url = `${config.url}${concator}${authstr}`
		//config.url = `/study${config.url}`
		if(!config.headers){
			config.headers = {}
		}
		//config.headers["X-Auth-Token"] = sessionStorage.getItem("AuthToken")
		//const token = sessionStorage.getItem("SAuthToken")
		//if(token) config.headers['Authorization'] = `bearer ${token}`
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)
Http.interceptors.response.use(
	(response) => {
		const data = response.data
		if (data.code === 401) {
			//未鉴权处理
			throw 401
		}
		if(data.code){
			if(data.code === 200){
				if(!data.data)return data
				return data.data
			}
			throw new Error(data.msg)
			
		}
		if(data.returnCode){
			if(data.returnCode === "1"){
				return data.value
			}
			throw new Error(data.message)
			
		}
		return data
	},
	(error) => {
		return Promise.reject(error)
	}
)

export default function install (Vue) {
	Vue.prototype.appName = window.VUE_APP_TITLE
	Vue.prototype.$baseURL = window.VUE_APP_BASEURL
	Vue.prototype.$get = Http.get
	Vue.prototype.$post = Http.post
	Vue.prototype.$util = window.util
	
	Object.keys(window.globalDefs).forEach(key=>{
		Vue.prototype[key] = window.globalDefs[key]
	})

	//弹窗消息
	Vue.prototype.$message = function (title, message, options){
		let args = {}
		args.type = options.type
		args.duration = 0.3
		args.position = "bottom-right"
		title = title.toString()
		if (typeof message === "object" && !options) {
			message = ""
			options = message
		}
		if (!message) message = ""
		if (typeof title === "string") args.title = title
		if (typeof message === "string") args.message = message
		return Vue.prototype.$dialog.alert({ ...args, ...options })
	}
	//顶部消息
	Vue.prototype.$notice = Notify
	"success,error,info,warn,warning，danger,primary".split(",").forEach(row => {
		Vue.prototype.$message[row] = (title, message, options = {}) => {
			if (row === "warn") row = "warning"
			if (row === "error") row = "danger"
			if (row === "info") row = "primary"
			options.type = row
			return Vue.prototype.$message(title, message, options)
		}
		Vue.prototype.$notice[row] = (title, dangerouslyUseHTMLString = false) => {
			title = title.toString()
			if (row === "warn") row = "warning"
			if (row === "error") row = "danger"
			if (row === "info") row = "primary"
			return Vue.prototype.$notice({
				type: row,
				message: title,
				showClose: true,
				dangerouslyUseHTMLString: dangerouslyUseHTMLString
			})
		}
	})
}
